import axios from '@/utils/request'
// 获取员工列表
export const getStoreClerkList = (params)=>{
 return axios.request({
    url: 'v1/storeClerk/index',
    method: 'get',
    params
  })
};
// 导出

export const getStoreClerkListExport = (params)=>{
  return axios.request({
     url: 'v1/storeClerk/export',
     method: 'get',
     params
   })
 };
//添加员工
export const storeClerkAdd = (data)=>{
 return axios.request({
  url: 'v1/storeClerk/index',
  method: 'post',
  data
  })
};
// 获取员工详情
export const getStoreClerkMore = (id)=>{
  return axios.request({
     url: 'v1/storeClerk/index/'+id,
     method: 'get'
  })
};
 // 修改员工
export const storeClerkEdit = (data,id)=>{
  return axios.request({
     url: 'v1/storeClerk/index/'+id,
     method: 'PUT',
     data
  })
};
 // 删除员工
export const storeClerkDel = (data)=>{
  return axios.request({
     url: 'v1/store/delete',
     method: 'post',
     data
  })
};
 // 修改员工状态
export const storeClerkStatus = (id,status)=>{
  return axios.request({
     url: 'v1/storeClerk/index/status/'+id+'/'+status,
     method: 'PUT'
  })
};
// 获取员工成长值
export const getStoreClerkPurchase = (params)=>{
  return axios.request({
     url: 'v1/storeClerk/growthRule/read',
     method: 'get',
     params
  })
};
// 设置员工成长值
export const setStoreClerkPurchase = (data)=>{
  return axios.request({
     url: 'v1/storeClerk/growthRule/save',
     method: 'post',
     data
  })
};
// 获取级别列表
export const getLevelList = (params)=>{
  return axios.request({
     url: 'v1/storeClerk/level',
     method: 'get',
     params
  })
};
// 级别详情
export const getlevelMore = (id)=>{
  return axios.request({
     url: 'v1/storeClerk/level/'+id,
     method: 'GET'
  })
};
// 级别
export const getlevelMax = (params)=>{
  return axios.request({
     url: 'v1/storeClerk/getMaxLevelByTypeId',
     method: 'GET',
     params
  })
};
// 添加级别
export const setlevelAdd = (data)=>{
  return axios.request({
     url: 'v1/storeClerk/level',
     method: 'post',
     data
  })
};
// 修改级别
export const levelEdit = (data,id)=>{
  return axios.request({
     url: 'v1/storeClerk/level/'+id,
     method: 'PUT',
     data
  })
};
// 删除级别
export const levelDel = (id)=>{
  return axios.request({
     url: 'v1/storeClerk/level/'+id,
     method: 'DELETE'
  })
};

// 获取类型列表
export const getTypeList = (params)=>{
  return axios.request({
     url: 'v1/storeClerk/type',
     method: 'get',
     params
  })
};
// 添加类型
export const TypeAdd = (data)=>{
  return axios.request({
     url: 'v1/storeClerk/type',
     method: 'post',
     data
  })
};
// 修改类型
export const typeEdit = (data,id)=>{
  return axios.request({
     url: 'v1/storeClerk/type/'+id,
     method: 'PUT',
     data
  })
};
// 删除类型
export const typeDel = (id)=>{
  return axios.request({
     url: 'v1/storeClerk/type/'+id,
     method: 'DELETE'
  })
};
// 生成链接
export const getInviteRegistered = (data)=>{
  return axios.request({
     url: 'v1/storeClerk/getInviteRegistered',
     method: 'post',
     data
  })
};
// 员工登录页模板设置
export const setStoreLoginTemplate = (data)=>{
  return axios.request({
     url: 'v1/storeClerk/loginTemplate/save',
     method: 'post',
     data
  })
};
// 员工登录页模板获取
export const getStoreLoginTemplate= (params)=>{
  return axios.request({
     url: 'v1/storeClerk/loginTemplate/read',
     method: 'get',
     params
  })
};

/**
 * 
 * 模板设置v2.0
 */  

// 门店店员菜单数据获取
export const getStoreClerkTemplateMenu = (params)=>{
  return axios.request({
    url: 'v2/storeClerk/menu',
    method: 'get',
    params
  })
};
// 门店店员后台首页设置
export const setStoreClerkTemplateMenu = (data)=>{
  return axios.request({
    url: 'v2/storeClerk/menuConfig',
    method: 'post',
    data
  })
};
// 门店店员常用功能-添加获取菜单数据
export const getStoreClerkUsedMenu = (params)=>{
  return axios.request({
    url: 'v2/storeClerk/menuListsOftenUse',
    method: 'get',
    params
  })
};
// 门店店员常用功能获取
export const getStoreClerkTemplateUsed = (params)=>{
  return axios.request({
    url: 'v2/storeClerk/oftenUseMenu',
    method: 'get',
    params
  })
};
// 门店店员常用功能添加
export const setStoreClerkTemplateUsed = (data)=>{
  return axios.request({
    url: 'v2/storeClerk/oftenUseMenu',
    method: 'post',
    data
  })
};

// 店员给积分
export const clerkGivePoint = (data)=>{
  return axios.request({
    url: 'v2/storeClerk/givePoint/'+data.clerk_id,
    method: 'post',
    data
  })
};
// 店员给成长值
export const clerkGiveExp = (data)=>{
  return axios.request({
    url: 'v2/storeClerk/giveExp/'+data.clerk_id,
    method: 'post',
    data
  })
};

// 获取店员成长值
export const getClerkGiveExp = (id)=>{
  return axios.request({
    url: 'v2/storeClerk/expDetail/'+id,
    method: 'get'
  })
};
 // 删除店员
export const clerkDel = (data)=>{
  return axios.request({
     url: '/v2/storeClerk/'+data.clerk_id,
     method: 'DELETE'
  })
};